import { eAccessRights, eReleaseStatus } from "functions/api/enums";
import { useContext } from "react";
import { AppSettingsContext } from "../AppSettingsContext";
import { ITlfContext } from "./interface";

/**
 * Provides TLF editor state and the derived read-only flag.
 *
 * @returns TLF state, application dispatch and the derived read-only flag.
 */
export const useTlfContext = (): ITlfContext => {
  const { state, dispatch } = useContext(AppSettingsContext);
  const { hierarchyState, tlfState } = state;
  const readOnly =
    tlfState.readOnly ||
    hierarchyState.hierarchy?.isBackupVersion === true ||
    !hierarchyState.accessRights.includes(eAccessRights.WriteToTlfItemsInHierarchy) ||
    (tlfState.tlfData !== null &&
      ![eReleaseStatus.Draft, eReleaseStatus.ReleasePending].includes(
        tlfState.tlfData.releaseStatus,
      ));
  return { ...tlfState, dispatch, readOnly };
};

useTlfContext.displayName = "useTlfContext";
